import React, { Component } from "react";

export default class BannerMail extends Component {
  render() {
    return <div className="banner_mail"></div>;
  }
}
